import mixpanelConstants from './mixpanelConstants';
import Tracker from '../common/Tracker';

const addCommonEventProperties = (props) => {
  let eventProperties = {};
  eventProperties[mixpanelConstants.eventProperties.exhibitorId] = props.exhibitorId;
  eventProperties[mixpanelConstants.eventProperties.exhibitorName] = props.exhibitorName;
  eventProperties[mixpanelConstants.eventProperties.component] = props.component;
  eventProperties[mixpanelConstants.eventProperties.packageType] = props.packageName;
  eventProperties[mixpanelConstants.eventProperties.productArea] = mixpanelConstants.propertyValue.exhibitors;
  eventProperties[mixpanelConstants.eventProperties.viewedElement] = props.viewedElement;
  eventProperties[mixpanelConstants.eventProperties.documentName] = props.documentName;
  eventProperties[mixpanelConstants.eventProperties.documentType] = props.documentType;
  eventProperties[mixpanelConstants.eventProperties.downloadUrl] = props.downloadUrl;
  eventProperties[mixpanelConstants.eventProperties.type] = props.type;
  eventProperties[mixpanelConstants.eventProperties.contactType] = props.contactType;
  eventProperties[mixpanelConstants.eventProperties.socialMedia] = props.socialMedia;
  eventProperties[mixpanelConstants.eventProperties.sortOption] = props.sortOption;
  eventProperties[mixpanelConstants.eventProperties.tabName] = props.tab;
  eventProperties[mixpanelConstants.eventProperties.profileSection] = props.profileSection;
  eventProperties[mixpanelConstants.eventProperties.entityAdded] = props.entityAdded;
  eventProperties[mixpanelConstants.eventProperties.entityRemoved] = props.entityRemoved;
  eventProperties[mixpanelConstants.eventProperties.productId] = props.productId;
  eventProperties[mixpanelConstants.eventProperties.productName] = props.productName;
  eventProperties[mixpanelConstants.eventProperties.subComponent] = props.subComponent;
  eventProperties[mixpanelConstants.eventProperties.element] = props.element;
  eventProperties[mixpanelConstants.eventProperties.twoFactor] = props.twoFactor;
  eventProperties[mixpanelConstants.eventProperties.actionOnVideo] = props.actionOnVideo;
  eventProperties[mixpanelConstants.eventProperties.videoId] = props.videoId;
  eventProperties[mixpanelConstants.eventProperties.playDuration] = props.playDuration;
  eventProperties[mixpanelConstants.eventProperties.totalVideoDuration] = props.totalVideoDuration;
  eventProperties[mixpanelConstants.eventProperties.percentageWatched] = props.percentageWatched;
  eventProperties[mixpanelConstants.eventProperties.hubVersion] = props.version;
  eventProperties[mixpanelConstants.eventProperties.adminRole] = props.adminRole;
  eventProperties[mixpanelConstants.eventProperties.sharerPackage] = props.sharerPackage;
  eventProperties[mixpanelConstants.eventProperties.operationalTaskName] = props.operationalTaskName;
  eventProperties[mixpanelConstants.eventProperties.taskCategory] = props.taskCategory;
  eventProperties[mixpanelConstants.eventProperties.taskStatus] = props.taskStatus;
  eventProperties[mixpanelConstants.eventProperties.completionStatus] = props.completionStatus;
  return eventProperties;
}

const getRootMargin = (component, eventName) => {
  const headerHeight = document.querySelector('header')?.offsetHeight ? document.querySelector('header').offsetHeight : 100;
  const global_nav = document.getElementsByClassName('global-nav__base')[0]?.offsetHeight
  const rootMargin = headerHeight - (global_nav ? global_nav : 0)
  let setRootMargin = '0px';
  const components = mixpanelConstants.component;
  const eventNames = mixpanelConstants.eventName;
  if(((component === components.exhibitorDirectory || component === components.homePage) && eventName === eventNames.exhibitorImpression) ||
      (component === components.productDirectory && eventName === eventNames.productImpression)){
    setRootMargin = `-${rootMargin}px 0px 0px 0px`
  }
  return setRootMargin;
}

const trackImpressions = (eventName, props, threshold = 1) => {
  let timer;
  const inViewTimeSpan = 3000;
  const rootMargin = getRootMargin(props?.component, props?.eventName);
  const firedTargets = new WeakSet();

  return new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if(entry.isIntersecting && !firedTargets.has(entry.target)){
        timer = setTimeout(() => {
          const otherProps = JSON.parse(entry.target.getAttribute('mixpanel-props'));
          if(otherProps){
            props = {...props, ...otherProps};
          }
          trackMixpanelEvent(eventName, props);
          firedTargets.add(entry.target);
          observer.unobserve(entry.target);
        }, inViewTimeSpan);
      }
      else{
        clearTimeout(timer);
      }
    });
  }, {
      threshold,
      rootMargin: rootMargin
    });
}

const trackMixpanelEvent = (eventName, props) => {
  const tracker = Tracker.getTracker();
  if(tracker){
    const eventProperties = addCommonEventProperties(props);
    tracker.track(eventName, eventProperties);
  }
}

module.exports = {
  trackMixpanelEvent, trackImpressions, getRootMargin, addCommonEventProperties
};
